import QuoteSection from "./QuoteSection";

export default QuoteSection;
